// extracted by mini-css-extract-plugin
export default {"CandidateShareContent__title":"ZA7K4","CandidateShareContent__inner":"MXv2E","CandidateShareContent__vettedSkillCard":"miFS3"};